import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { forgot_password } from '../services';
import AuthLayout, { trackPointer, Field, AlertCircleIcon, CheckCircleIcon, ArrowRightIcon, ArrowLeftIcon, MailIcon } from './AuthLayout';
function KeyIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7.5" cy="15.5" r="5.5"/>
      <path d="M21 2l-9.6 9.6M15.5 7.5l3 3M17 6l3 3"/>
    </svg>
  );
}

function ForgetPassword() {
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({ email: '' });
    const [resMsg, setResMsg] = useState('');
    const [errResMsg, setErrResMsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        const setters = { email: setEmail };
        if (setters[name]) { setters[name](value); }
        setErrors({});
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (!validate()) { setIsLoading(false); return; }
        try {
            const passData = { emailId: email };
            const response = await forgot_password(passData);
            const status = response?.statusCode?.status;
            const responseData = response?.statusCode?.response_data;
            const successMessage = responseData?.message;
            const is_reset = responseData?.data?.is_reset;
            const get_email = responseData?.data?.email;
            const errorMessage = response?.errors?.message;
            const errResMsg = response?.error?.message;
            if (status === 1 && successMessage) {
                setResMsg(successMessage);
                setErrResMsg('');
                sessionStorage.setItem('is_otp_allowed', 'forgot');
                sessionStorage.setItem('otp_source_page', location.pathname);
                sessionStorage.setItem('otp_email', get_email);
                sessionStorage.setItem('is_reset', String(is_reset));
                navigate('/otp-verification', { state: { email: get_email, isReset: is_reset } });
                setIsLoading(false);
            } else if (errResMsg) {
                setErrResMsg(errResMsg);
                setResMsg('');
                setIsLoading(false);
            } else if (errorMessage) {
                setErrResMsg(errorMessage);
                setIsLoading(false);
            }
        } catch (error) {
            console.error('API Error:', error);
            setErrResMsg('Network error. Please try again later.');
            setResMsg('');
            setIsLoading(false);
        }
    };

    const validate = () => {
        let emailError = '';
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) { emailError = 'Email is required'; setIsLoading(false); }
        else if (!emailRegex.test(email)) { emailError = 'Enter a valid email'; setIsLoading(false); }
        setErrors({ email: emailError });
        return !emailError;
    };

    return (
        <AuthLayout>
            <AuthLayout.Stage/>
            <AuthLayout.Panel>
            <div className="lg-wrap">
                <header className="lg-form-header">
                    <p className="lg-eyebrow"><KeyIcon/> Password recovery</p>
                    <h1 className="lg-title" id="lg-fp-title">Forgot your password?</h1>
                    <p className="lg-lead">
                        Enter the email you used to create your account and we will send you a reset code.
                    </p>
                </header>

                {errResMsg && (
                    <div className="lg-alert lg-alert--error" role="alert">
                        <AlertCircleIcon/> <span>{errResMsg}</span>
                    </div>
                )}
                {resMsg && (
                    <div className="lg-alert lg-alert--success" role="status">
                        <CheckCircleIcon/> <span>{resMsg}</span>
                    </div>
                )}

                <form className="lg-form" noValidate onSubmit={submitHandler}>
                    <Field name="email" type="email" label="Work email" icon={<MailIcon/>}
                        value={email} onChange={onChangeHandler} error={errors.email} autoComplete="email"/>

                    <button type="submit" className="lg-submit lg-spot"
                        disabled={isLoading} aria-busy={isLoading} onPointerMove={trackPointer}>
                        {isLoading ? (
                            <span className="lg-submit-label"><span className="lg-spin" aria-hidden="true"/> Sending code...</span>
                        ) : (
                            <span className="lg-submit-label">Send reset code <ArrowRightIcon/></span>
                        )}
                        {isLoading && <i className="lg-scan" aria-hidden="true"/>}
                    </button>
                </form>

                <p className="lg-signup">
                    <button type="button" className="lg-back-btn" onClick={() => navigate('/')}>
                        <ArrowLeftIcon/> Back to login
                    </button>
                </p>
            </div>

            <p className="lg-trust">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <rect x="4.5" y="10.5" width="15" height="10" rx="3"/>
                    <path d="M8 10.5V8a4 4 0 018 0v2.5"/>
                </svg>
                Your account is protected with industry-standard encryption.
            </p>
            </AuthLayout.Panel>
        </AuthLayout>
    );
}

export default ForgetPassword;
